/* eslint-disable react/jsx-props-no-spreading */
import React, { ComponentType } from 'react';
import { RefreshPageButton } from 'common/refresh-page-button';
import { Auth } from './auth';

const withAuth =
  <TOriginalProps extends {}>(
    Component: ComponentType<TOriginalProps>,
    optional?: boolean,
  ) =>
  (props: TOriginalProps) => (
    <Auth optional={optional}>
      <Component {...props} />
      <RefreshPageButton />
    </Auth>
  );

export { withAuth };
